module.exports = __webpack_public_path__ + "static/media/IntroS4CharacterCardA0001Pigsy_design_clean_v001.fb458638.webp";